<template>
  <div :class="['content mb-5', { 'policy-no-subtitle': !pageMeta.subTitle }]">
    <t-sub-nav
      class="mb-5"
      :loading="loading"
      :items="
        $secondaryNav.customerDefaultPolicyNavItems(
          hasVirtualLocation(selectedCustomerPolicy)
        )
      "
    />
    <b-row>
      <b-col>
        <h2 class="mb-3">{{ this.$t("Locations using this policy") }}</h2>
        <t-data-table
          data-test-id="policies-sites-data-table"
          disable-row-select
          with-filter
          hoverable
          :filter-placeholder="$t('Search Locations')"
          :loading="loading"
          :table-data="dataSet"
          :actions="tableActions"
          @on-add="onAdd"
          @on-export="onExport"
          @on-row-clicked="onRowClicked"
          @export-headers="exportedHeaders"
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "Customer Default Locations",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>
<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import policySubPages from "@/mixins/policySubPages";

export default {
  layout: "customer",
  mixins: [policySubPages],
  watch: {
    selectedCustomerPolicy(newSelectedCustomerPolicy) {
      this.dataSet.items = newSelectedCustomerPolicy.locations;
    },
  },
  data: function () {
    return {
      loading: true,
      currentHeaders: null,
      tableActions: {
        add: {
          enabled: false,
        },
        import: { enabled: false },
        export: { enabled: true },
        delete: { enabled: true },
      },
      searchExports: ["name", "ip", "type"],
      dataSet: {
        fields: [
          { value: "name", text: this.$t("Location Name"), sortable: true },
          { value: "ip", text: this.$t("IP Address"), sortable: true },
          { value: "type", text: this.$t("Type"), sortable: false },
          { value: "id", text: this.$t("Location ID"), sortable: false },
        ],
        items: [],
      },
    };
  },
  methods: {
    ...mapMutations("modal", ["createModal", "showModal"]),
    ...mapActions("customerPolicies", ["fetchCustomerPolicy"]),
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    onAdd({ name, modal, type }) {
      this.createModal({
        modal,
        title: this.$t("Add Site"),
        dataTestId: `modal-add-site-${type}`,
        subtitle: name,
        modalData: {
          type,
          customerPolicies: this.customerPolicies,
        },
        props: {
          size: "lg",
          okTitle: this.$t("Save"),
        },
      });

      this.showModal();
    },
    onImport(items) {
      console.log("Import items:", items); // eslint-disable-line no-console
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "locations");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No locations in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
    onRowClicked(item) {
      this.$router.push({
        path: `/customer/environment/locations/${item.id}?type=${item.type}`,
      });
    },
  },
  computed: {
    ...mapGetters("customerPolicies", ["selectedCustomerPolicy"]),
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("pageMeta", ["pageMeta"]),
  },
  async created() {
    await Promise.all([
      this.fetchCustomerPolicy({
        id: this.selectedUser.id,
        policyId: "default",
      }),
    ]);

    this.loading = false;
  },
  mounted() {
    this.setPageTitle(this.$t("Default Policy"));
    this.setPageSubtitle([
      this.$t(
        "Policies determine what categories of website a user can see. This is your default policy and is automatically assigned to all new locations, devices, users and groups added to Web Protection, unless you apply a policy you have created in Content Filtering > Policies"
      ),
    ]);
  },
};
</script>
